import { jsx as _jsx } from "react/jsx-runtime";
import PropertyInfoField from "../PropertyInfoField";
export var PropertyInfoFieldJsonFormSchema = function (props) {
    var uiSchema = props.uiSchema;
    var customUiSchema = uiSchema;
    // Render
    return (_jsx(PropertyInfoField, { property: customUiSchema.property, propertyId: customUiSchema.propertyId }));
};
export default PropertyInfoFieldJsonFormSchema;
